/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Azure subscription configuration. Applicable if `cloudProvider` is set to `AZURE`. 
*/
export class AzureRestoreAccountAttributesInput {
  /**
  * ID of the tenant the subscription belongs to.
  */
  'tenantId': string;
  /**
  * Subscription ID. 
  */
  'subscriptionId': string;
  /**
  * Resource group name.
  */
  'resourceGroupName'?: string;
  /**
  * The location of the resources
  */
  'location'?: string;
  /**
  * Resource group name for Eon\'s temporary internal resources. 
  */
  'eonInternalResourceGroupName'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": ""
    },
    {
      "name": "subscriptionId",
      "baseName": "subscriptionId",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceGroupName",
      "baseName": "resourceGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": ""
    },
    {
      "name": "eonInternalResourceGroupName",
      "baseName": "eonInternalResourceGroupName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureRestoreAccountAttributesInput.attributeTypeMap;
  }

  public constructor() {
  }
}

